import { actionGenerator, IReduxAction } from '../../utils/actions';

export const UPDATE_USER_BALANCE = 'USER :: UPDATE_BALANCE';

export interface IUpdateUserBalanceActionPayload {
  balance: number;
}

export type TUpdateUserBalanceAction = IReduxAction<typeof UPDATE_USER_BALANCE, IUpdateUserBalanceActionPayload>;

export const updateUserBalance = actionGenerator<typeof UPDATE_USER_BALANCE, IUpdateUserBalanceActionPayload>(
  UPDATE_USER_BALANCE,
);
